import { render, staticRenderFns } from "./platformDeposit.vue?vue&type=template&id=ac4f86be&scoped=true"
import script from "./platformDeposit.vue?vue&type=script&lang=js"
export * from "./platformDeposit.vue?vue&type=script&lang=js"
import style0 from "./platformDeposit.vue?vue&type=style&index=0&id=ac4f86be&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4f86be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac4f86be')) {
      api.createRecord('ac4f86be', component.options)
    } else {
      api.reload('ac4f86be', component.options)
    }
    module.hot.accept("./platformDeposit.vue?vue&type=template&id=ac4f86be&scoped=true", function () {
      api.rerender('ac4f86be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/financeManagement/platformDeposit/platformDeposit.vue"
export default component.exports